export default "/_next/static/da483aec6935cafa5f4dbf3099aace6a.png";